import { useMemo } from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon, GetApp as GetAppIcon } from '@mui/icons-material';
import { waterlineItemReport } from './WaterlineReports';
import { Room, WaterlineItem } from './types';
import WaterlineInventoryTable from './WaterlineInventoryTable';
import { useNavigate } from 'react-router-dom';
import useCustomer from '../../../hooks/useCustomer';

interface WaterlineInventoryProps {
  inventoryItems: WaterlineItem[];
  rooms: Room[];
  onRefresh: () => Promise<void>;
}

const WaterlineInventory: React.FC<WaterlineInventoryProps> = ({ inventoryItems, rooms, onRefresh }) => {
  const navigate = useNavigate();
  const customer = useCustomer()

  const waterlineStraws = useMemo(() => {
    return inventoryItems.filter((item) => {
      return item.subcategory?.toLowerCase() === 'straws';
    });
  }, [inventoryItems]);

  const waterlineTreatment = useMemo(() => {
    return inventoryItems.filter((item) => {
      return item.subcategory?.toLowerCase() === 'treatment' || item.subcategory?.toLowerCase() === 'tablets';
    });
  }, [inventoryItems]);

  const waterlineTesting = useMemo(() => {
    return inventoryItems.filter((item) => {
      return item.subcategory?.toLowerCase() === 'mail-test' || item.subcategory?.toLowerCase() === 'in-office';
    });
  }, [inventoryItems]);

  return (
    <>
      <div className="flex flex-end m-b-16">
        <Button
          component="button"
          onClick={() => navigate('/practice/auto-renewals')}
          startIcon={<AddIcon />}
          variant="contained"
          style={{ marginRight: '16px' }}
        >
          Enroll in Auto Shipments
        </Button>
        <Button onClick={() => waterlineItemReport(inventoryItems, customer, true)} startIcon={<GetAppIcon />} variant="contained">
          Export All
        </Button>
      </div>
      {waterlineStraws.length > 0 && <WaterlineInventoryTable customer={customer} name={"Water Straws"} rooms={rooms} items={waterlineStraws} onRefresh={onRefresh} />}
      {waterlineTreatment.length > 0 && <WaterlineInventoryTable customer={customer} name={"Water Treatment"} rooms={rooms} items={waterlineTreatment} onRefresh={onRefresh} />}
      {waterlineTesting.length > 0 && <WaterlineInventoryTable customer={customer} name={"Water Testing"} rooms={rooms} items={waterlineTesting} onRefresh={onRefresh} />}
    </>
  );
};

export default WaterlineInventory;
